// angular
import { Component, computed, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// components
import { TextSummarizerComponent } from '../text-summarizer/text-summarizer.component';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
// types
import { IProject } from '@app/+projects/shared/types/project.interface';

@Component({
  selector: 'pwj-project-card',
  templateUrl: './project-card.component.html',
  standalone: true,
  imports: [
    RouterLink,
    NgOptimizedImage,
    TranslateModule,
    TextSummarizerComponent,
    TranslateDataPipe,
    ImageSourcePipe,
  ],
  styleUrls: [
    '../product-card/product-card.component.scss',
    './project-card.component.scss',
  ],
  host: {
    class: 'product-card-host--compact',
  },
})
export class ProjectCardComponent {
  data = input.required<IProject>();

  readonly coverImage = computed(() => {
    const photo = this.data()?.photos?.[0];
    return (
      photo?.cropped_url?.toLowerCase() ||
      photo?.url?.toLowerCase() ||
      photo?.url ||
      null
    );
  });

  readonly subtitle = computed(() => {
    const category = this.data()?.category?.title;
    if (category) return category;
    return null;
  });
}
